import { map, catchError, mergeMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { Observable, of } from 'rxjs';

import { AuthService } from 'src/app/services/auth.service';

import * as ReportsActions from './reports.actions';

@Injectable()
export class ReportsEffects {
    getDailyReports$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ReportsActions.GET_DAILY_REPORTS),
            map(reports => {
                if (reports) {
                    return Observable.create({});
                }
            }),
            catchError(err => of(ReportsActions.error({ error: err.message })))
        )
    );

    getWeeklyReports$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ReportsActions.GET_MONTHLY_REPORTS),
            map(reports => {
                if (reports) {
                    return Observable.create({});
                }
            }),
            catchError(err => of(ReportsActions.error({ error: err.message })))
        )
    );

    getMonthlyReports$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ReportsActions.GET_MONTHLY_REPORTS),
            map(reports => {
                if (reports) {
                    return Observable.create({});
                }
            }),
            catchError(err => of(ReportsActions.error({ error: err.message })))
        )
    );

    constructor(
        private actions$: Actions,
        private authService: AuthService
    ) {}
}